import {AdminEntityService} from "./AdminEntityService";
import {ListRequest, UserGroup, ListUserGroupResponse} from "../../../generated/protocol";
import {AbstractAdminEntityService} from "./AbstractAdminEntityService";
import {injectable} from "inversify";

export const USER_GROUP_SERVICE_NAME = "userGroupService";

export interface UserGroupService extends AdminEntityService<UserGroup> {

    listPermissionCategories(): Promise<string[]>;

    fetchUserGroup(nameId: string): Promise<UserGroup>

    updateGroup(userGroup: UserGroup): Promise<UserGroup>;

    createGroup(userGroup: UserGroup): Promise<UserGroup>;

    list(listRequest: ListRequest): Promise<ListUserGroupResponse>;
}

@injectable()
export class UserGroupServiceImpl extends AbstractAdminEntityService<UserGroup, ListUserGroupResponse> implements UserGroupService {

    constructor() {
        super("/user-group")
    }

    listPermissionCategories(): Promise<string[]> {
        return this.http.doGet<string[]>(this.entityPath + "/list-permission-categories");

    }

    fetchUserGroup(nameId: string): Promise<UserGroup> {
        return this.http.doGet<UserGroup>("/user-group/" + nameId);
    }

    updateGroup(userGroup: UserGroup): Promise<UserGroup> {
        return this.http.doPost<UserGroup, UserGroup>(this.entityPath + "/update", userGroup);
    }

    createGroup(userGroup: UserGroup): Promise<UserGroup> {
        return null;
    }


}


// WEBPACK FOOTER //
// ./src/app/service/admin/UserGroupService.ts